import React, {Component} from "react";
import SimpleDate from "../../../../../modules/SimpleDate";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleInput from "../../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../../modules/simpleTextArea";

class ReceivingUnitDGIInputs extends Component {
    handleInputChange = (name, value) => {
        this.props.onSetState((prevValue) => ({
            ...prevValue,
            data: {...prevValue.data, [name]: value},
        }));
    };

    render() {
        return (
            <>
                <div className="grid grid-3x grid-mobile-none gap-15px" style={{alignItems: "center"}}>
                    <div id="grid-1">
                        <SimpleInput
                            id="input_text_no_spbm"
                            name="nospbm"
                            label="No. SPBM"
                            readOnly
                            value={this.props.state.data.spbmNo || this.props.state?.placeholderSPBMNo}
                        />
                        <SimpleInput
                            id="input_text_no_sl"
                            name="nosl"
                            label="No. SL"
                            readOnly
                            value={this.props.state.data.slNo}
                        />
                        <SimpleInput
                            id="input_text_no_invoice"
                            name="noinvoice"
                            label="No. Invoice"
                            readOnly
                            value={this.props.state.data.noInvoice}
                        />
                    </div>
                    <div id="grid-2">
                        <SimpleDate
                            id="select_date_tgl_spbm"
                            label="Tgl. SPBM"
                            disabled
                            date={new Date()}
                        />
                        <SimpleDate
                            id="select_date_tgl_sl"
                            name="tanggalsl"
                            label="Tanggal SL"
                            disabled
                            date={this.props.state.data.slDate}
                        />
                        <SimpleInput
                            id="input_text_poid"
                            name="poid"
                            label="PO id"
                            readOnly
                            value={this.props.state.data.poId}
                        />
                    </div>
                    <div id="grid-3">
                        <SimpleInput
                            id="input_text_nama_supp"
                            name="namasupp"
                            label="Nama Supp."
                            value={this.props.state.data?.namaSupplier}
                            readOnly
                        />
                        <SimpleInput
                            id="input_text_no_pol_truk"
                            name="noPolisi"
                            label="No. Pol Truk"
                            value={this.props.state.data.noPolisi}
                            onChange={({target}) => this.handleInputChange(target.name, target.value)}
                        />
                        <SimpleDDL
                            id="select_options_ekpedisi"
                            box="search"
                            name="kodeSupplierExpedisi"
                            label="Ekspedisi"
                            isClearable={true}
                            options={this.props.state.expedisiOptions}
                            value={this.props.state.data.kodeSupplierExpedisi}
                            onChange={(value, {name}) => this.handleInputChange(name, value)}
                        />
                    </div>
                </div>
                <div
                    style={{
                        display: "grid",
                        gap: "15px",
                        gridTemplateColumns: "1fr 1fr",
                    }}
                >
                    <SimpleTextArea
                        typeInputCase="normal"
                        name="description"
                        label="Catatan"
                        value={this.props.state.data.description || ""}
                        onChange={({target}) => this.handleInputChange(target.name, target.value)}
                    />
                    {this.props.state.data.kodeSupplierExpedisi && (
                        <p style={{justifySelf: "end"}}>{this.props.state.data.kodeSupplierExpedisi.name}</p>
                    )}
                </div>
            </>
        );
    }
}

export default ReceivingUnitDGIInputs;
